import axios from "axios";
import { constantsOauth } from "../config";

export const AFFILIATES_AGENCY_VIEW = "gameboy:affiliatesAgency";

export const GAMEBOY_PERMISSION_RESOURCES = ["gameboy", AFFILIATES_AGENCY_VIEW];

const DENIED_PERMISSIONS = {
  view: false,
  edit: false,
  create: false,
  admin: false,
};

const replaceAll = (str, search, replacement) =>
  str.split(search).join(replacement);

const getAllSubMenusPermissions = resource => {
  const temp = replaceAll(resource, ":*", "").split(":");
  const arrayReturn = [];
  let tempString = "";

  temp.forEach(part => {
    tempString += part;
    arrayReturn.push(tempString);
    tempString += ":";
  });

  return arrayReturn;
};

export const extractViewsAllowed = (arrayPermissions, permissions = []) => {
  const permissionsAllowed = (permissions || []).map(permission => {
    const primaryResource = permission.resources?.[0] || "";
    const submenus = getAllSubMenusPermissions(primaryResource);
    const matchedResources = arrayPermissions.filter(ap =>
      ap.match(replaceAll(primaryResource, "*", ".*"))
    );
    const resources = matchedResources
      .concat(submenus.length === 1 ? submenus : submenus.slice(0, -1))
      .concat(permission.resources || []);

    return {
      actions: permission.actions || [],
      resources: [...new Set(resources)],
    };
  });

  return {
    permissionsAllowed,
    menuAllowed: new Set(
      permissionsAllowed.flatMap(permission => permission.resources)
    ),
  };
};

export const resolveActionsToPermissions = (actions = []) => {
  const isWildcard = actions.includes("*");
  const isAdmin = isWildcard || actions.includes("admin");

  return {
    view: isAdmin || isWildcard || actions.includes("view"),
    edit: isAdmin || isWildcard || actions.includes("edit"),
    create: isAdmin || isWildcard,
    admin: isAdmin,
  };
};

export const getPermissionsForView = (viewName, viewsAllowed) => {
  if (!viewsAllowed?.permissionsAllowed) {
    return { ...DENIED_PERMISSIONS };
  }

  let actionsAllowed = [];

  viewsAllowed.permissionsAllowed.forEach(permission => {
    if (new Set(permission.resources).has(viewName)) {
      actionsAllowed = permission.actions;
    }
  });

  return resolveActionsToPermissions(actionsAllowed);
};

export const isViewAllowed = (viewName, viewsAllowed) =>
  viewsAllowed?.menuAllowed ? viewsAllowed.menuAllowed.has(viewName) : false;

export const normalizeUserPermissions = (authData, profile) => {
  if (authData?.permissions && Array.isArray(authData.permissions)) {
    return authData.permissions;
  }

  if (profile?.permissions) {
    return Array.isArray(profile.permissions)
      ? profile.permissions
      : [profile.permissions];
  }

  return [];
};

export const fetchAuthorizationData = async accessToken => {
  if (typeof accessToken !== "string") {
    return {};
  }

  const authorization =
    accessToken.substring(0, 7) === "Bearer "
      ? accessToken
      : `Bearer ${accessToken}`;

  try {
    const result = await axios.get(constantsOauth.userInfoUrl, {
      headers: { Authorization: authorization },
      params: { scope: "openid role" },
    });

    return result.status === 200 ? result.data : {};
  } catch (error) {
    console.error("Error fetching authorization data:", error);
    return {};
  }
};

export const buildViewsAllowedFromAuth = (authData, profile) => {
  const permissions = normalizeUserPermissions(authData, profile);
  return extractViewsAllowed(GAMEBOY_PERMISSION_RESOURCES, permissions);
};
